import React from 'react';

import { css } from '@emotion/react';

import { AddressInput } from 'src/clients/Network/gql/types/address';
import Button from 'src/components/creditApplication/Button';
import CreditApplicationPageLayout from 'src/components/creditApplication/CreditApplicationPageLayout';
import SelectMenu from 'src/components/creditApplication/SelectMenu';
import TextInput from 'src/components/creditApplication/TextInput';
import { StateMenuActions } from 'src/utils/address';

interface IPropsIface {
  onContinue: (address: AddressInput) => void;
  prefillAddress?: AddressInput;
  loading: boolean;
}

const AddressEntryPage = ({ onContinue, prefillAddress, loading }: IPropsIface) => {
  const [street, setStreet] = React.useState(prefillAddress?.primaryAddressLine ?? '');
  const [unit, setUnit] = React.useState(prefillAddress?.secondaryAddressLine ?? '');
  const [city, setCity] = React.useState(prefillAddress?.locality ?? '');
  const [state, setState] = React.useState(prefillAddress?.subdivision ?? '');
  const [zip, setZip] = React.useState(prefillAddress?.zip5 ?? '');

  const buttonState = React.useMemo(() => {
    return loading
      ? 'loading'
      : zip.length === 5 && street.length > 0 && city.length > 0 && state.length > 0
        ? 'default'
        : 'disabled';
  }, [loading, zip, street, city, state]);

  const onChangeStreet = React.useCallback(({ value }: { value: string }) => {
    setStreet(value);
  }, []);

  const onChangeUnit = React.useCallback(({ value }: { value: string }) => {
    setUnit(value);
  }, []);

  const onChangeCity = React.useCallback(({ value }: { value: string }) => {
    setCity(value);
  }, []);

  const onChangeState = React.useCallback(({ value }: { value: string }) => {
    setState(value);
  }, []);

  const onChangeZip = React.useCallback(({ value }: { value: string }) => {
    setZip(value);
  }, []);

  const handleContinue = React.useCallback(() => {
    onContinue({
      primaryAddressLine: street,
      secondaryAddressLine: unit,
      locality: city,
      subdivision: state,
      zip5: zip,
    });
  }, [onContinue, street, unit, city, state, zip]);

  return (
    <CreditApplicationPageLayout title='Enter your residential address'>
      <div css={root}>
        <div css={inputContainer}>
          <TextInput placeholder='Street' value={street} onChange={onChangeStreet} />
          <TextInput placeholder='Unit' value={unit} onChange={onChangeUnit} />
          <TextInput placeholder='City' value={city} onChange={onChangeCity} />
          <SelectMenu options={StateMenuActions} value={state} onChange={onChangeState} placeholder='State' />
          <TextInput placeholder='Zip' inputMode='numeric' maxLength={5} value={zip} onChange={onChangeZip} />
        </div>
        <Button label='Continue' type='button' width='full' onClick={handleContinue} state={buttonState} />
      </div>
    </CreditApplicationPageLayout>
  );
};

const root = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 40px;
`;

const inputContainer = css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;
`;

export default AddressEntryPage;
